import { SgVersionCacheFactory } from './SgVersionCacheFactory';
import { VersionHistory } from './types';

export class SgVersionCache<T> implements VersionHistory<T> {
  private cacheImplementation: VersionHistory<T>;

  constructor(useSessionStorage: boolean, cacheLimit: number) {
    this.cacheImplementation = SgVersionCacheFactory.createCache<T>(
      useSessionStorage,
      cacheLimit,
    );
  }

  getVersion(index: number): T | null {
    return this.cacheImplementation.getVersion(index);
  }

  pushVersion(data: T): number {
    return this.cacheImplementation.pushVersion(data);
  }

  getLastVersionIndex(): number {
    return this.cacheImplementation.getLastVersionIndex();
  }

  getAvailableVersionIndexes(): number[] {
    return this.cacheImplementation.getAvailableVersionIndexes();
  }
}
